import React from 'react';
import RenderSection from './RenderSection';
import FlightsSearchLayout from '../FlightsSearchLayout';

const MultipleFlights = ({
  airSectionRow,
  setAirSectionRow,
  handleClick,
  showPassengers,
  handleClose,
  searchPax,
  setSearchPax,
  flightClass,
  setFlightClass,
  executeSearch,
  hasErrorMessage,
}) => {
  const addFlightSection = () => {
    setAirSectionRow(prev => [
      ...prev,
      { origin: undefined, destination: undefined, date: undefined },
    ]);
  };

  const removeFlightSection = index => {
    setAirSectionRow(prev => prev.filter((_, i) => i !== index));
  };

  const updateSection = (index, field, value) => {
    setAirSectionRow(prev => {
      const newAirSection = [...prev];
      newAirSection[index][field] = value;
      if (field === 'date') {
        return validateDates(newAirSection);
      }
      return newAirSection;
    });
  };

  const validateDates = dates => {
    for (let i = 1; i < dates.length; i++) {
      const prevDateStr = dates[i - 1].date || '';
      const currentDateStr = dates[i].date || '';

      const prevDate = new Date(prevDateStr.replace(/\//g, '-'));
      const currentDate = new Date(currentDateStr.replace(/\//g, '-'));

      if (currentDate < prevDate) {
        dates[i].date = dates[i - 1].date;
      }
    }
    return dates;
  };

  return (
    <FlightsSearchLayout
      layoutType="multidestino"
      renderSection={(section, i) => (
        <RenderSection
          key={'render-section' + i}
          id={'md-render-section' + i}
          section={section}
          i={i}
          updateSection={updateSection}
          airSectionRow={airSectionRow}
          addFlightSection={addFlightSection}
          removeFlightSection={removeFlightSection}
        />
      )}
      {...{
        addFlightSection,
        removeFlightSection,
        handleClick,
        showPassengers,
        handleClose,
        searchPax,
        setSearchPax,
        setFlightClass,
        flightClass,
        executeSearch,
        hasErrorMessage,
        airSectionRow,
      }}
    />
  );
};

export default MultipleFlights;
